var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddtext(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3004 6.18066C11.866 6.18066 12.3245 6.63919 12.3245 7.2048V10.2772H15.3969C15.9625 10.2772 16.4211 10.7357 16.4211 11.3014C16.4211 11.867 15.9625 12.3255 15.3969 12.3255H12.3245V15.3979C12.3245 15.9635 11.866 16.422 11.3004 16.422C10.7348 16.422 10.2762 15.9635 10.2762 15.3979V12.3255H7.20383C6.63821 12.3255 6.17969 11.867 6.17969 11.3014C6.17969 10.7357 6.63821 10.2772 7.20383 10.2772H10.2762V7.2048C10.2762 6.63919 10.7348 6.18066 11.3004 6.18066Z",
    fill: "#A8A8A8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3007 2.08392C6.21013 2.08392 2.08343 6.21062 2.08343 11.3012C2.08343 16.3917 6.21013 20.5184 11.3007 20.5184C16.3912 20.5184 20.5179 16.3917 20.5179 11.3012C20.5179 6.21062 16.3912 2.08392 11.3007 2.08392ZM0.0351562 11.3012C0.0351562 5.07939 5.0789 0.0356445 11.3007 0.0356445C17.5224 0.0356445 22.5662 5.07939 22.5662 11.3012C22.5662 17.5229 17.5224 22.5667 11.3007 22.5667C5.0789 22.5667 0.0351562 17.5229 0.0351562 11.3012Z",
    fill: "#A8A8A8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddtext);
export default __webpack_public_path__ + "static/media/addtext.9f1ec92feb4a24b145793c15a028a9e7.svg";
export { ForwardRef as ReactComponent };